<div class="wrapper">
  <app-testing-from [data]="data" />
  <app-actions-section
    [disableAddMenu]="disableAddMenu"
    class="actions-section w-[455px]"
  />
</div>
